module.exports = __webpack_public_path__ + "static/media/Lobby.dd00ec60.jpg";